import { render, staticRenderFns } from "./CategoryForm.vue?vue&type=template&id=637219d1&scoped=true&"
import script from "./CategoryForm.vue?vue&type=script&lang=js&"
export * from "./CategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./CategoryForm.vue?vue&type=style&index=0&id=637219d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637219d1",
  null
  
)

export default component.exports